"use client"

import type { FeedExperiment } from "@/features/feed/contract"
import { useVisibleExposure } from "@/platform/experiments/use-visible-exposure"
import { trackExperimentInclusion } from "@/platform/observability/analytics/v2/experiments"

interface FeedExperimentTrackerProps {
  experiment: FeedExperiment
}

// `trackingKey` is GrowthBook's own key for the running experiment; it is what joins this
// event to the backend inclusion log, and it falls back to the feature name on force rules.
export const FeedExperimentTracker = ({ experiment }: FeedExperimentTrackerProps) => {
  const { experimentKey, trackingKey, variation } = experiment

  useVisibleExposure(`${experimentKey}:${trackingKey ?? experimentKey}:${variation}`, () => {
    trackExperimentInclusion({
      feature_name: experimentKey,
      tracking_key: trackingKey ?? experimentKey,
      treatment_name: variation,
    })
  })

  return null
}
